import { Component, OnInit } from '@angular/core';
import { HrmsService,MasterService } from '../../services/index';
import { HttpClient } from '@angular/common/http';
import {NgbModal, ModalDismissReasons,NgbModalOptions,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-workdairy',
  templateUrl: './workdairy.component.html',
  styleUrls: ['./workdairy.component.scss'],
  providers:[HrmsService,MasterService]
})
export class WorkdairyComponent implements OnInit {

  sections:any=[];
  arrstaff:any=[];
  classes:any=[];
  attcordata:any=[];
  arrsubjects:any=[];
  fmodel:any={clid:'0',secid:'0',subid:'0',prid:'0',atscope:'Individual'};
  attdata:any=[];
  arrper:any=[];
  attcordetdata:any=[];
  arrcnmcls:any=[];
  arrcourse:any=[];
  arrworklist:any=[];
  attcondata:any=[];
  oprtype:any='';
  tabledata: any = {};
  objclass:any={};
  arrstulst:any=[];
  fmodel1:any={};
  cmodel:any={};
  amodel:any={};
  objoffline:any={};
  objoff:any={clid:'0',scid:'0',crid:'0'};
  objvhead:any={};
  arrcmbdet:any=[];
  msgexist="";
  corclasses:any=[];
  corsections:any=[];
  corsubjects:any=[];
  arrwktype:any=[];
  arrwkstatus:any=[];
  modalOptions:NgbModalOptions;
  private modalRef: NgbModalRef;
  arratscope:any=[{name:'Individual'},{name:'Combined'}];
  arropt:any=[{name:'Yes'},{name:'No'}];

  dropdownList = [];
  selectedItems = [];
  colums:any=[];
  objsubalot:any={};
  completeDate: Date;
  localCompleteDate: string;
  arroff: any;
  arflstudent: any;
  arreval: any;
  
  constructor(private http: HttpClient, private sservice: HrmsService,private mservice:MasterService,private modalService: NgbModal) { 

    this.completeDate = new Date();
    this.localCompleteDate = this.completeDate.toISOString();
    this.localCompleteDate = this.localCompleteDate.substring(0, 16).replace("T"," ");
  }
  
  ngOnInit(): void {
    
    
this.mascourse();
    this.masgeneral('wkstatus');
    this.masgeneral('wktype');
    //this.onclickcorrection();
   
  }

  addstudents()
  {

    console.log(this.selectedItems);
  }

   printcertificate(){
  debugger
  var clcd=localStorage.getItem('clcd');
  var aycd=localStorage.getItem('aycd');

   var url=this.mservice.callurl+"/fpdf181/pdfreports/staffactivity.php?clcd="+clcd+"&aycd="+aycd+"&emid="+this.objoff.emid+"&frdt="+this.objoff.frdt+"&todt="+this.objoff.todt;

   window.open(url,'');
  
 }

  corclass() {
    this.mservice.classmasterrolewise(0,this.cmodel.crid,0,'class')
        .subscribe(
        resultArray => {
            console.log('getdashcounts', resultArray);
           // resultArray.unshift({clid:"0",clnm:"ALL",clcd:"ALL"});
           var res=resultArray;
            this.corclasses = res;
            
            this.cmodel.clid=res[0].clid;
            this.amodel.clid=res[0].clid;
            this.corsection();
           // this.masperiod();
           // this.mascourse();
           
        },
        error => console.log("Error :: " + error)
        )
  }


  corclass1() {
    this.mservice.classmasterrolewise(0,this.amodel.crid,0,'class')
        .subscribe(
        resultArray => {
            console.log('getdashcounts', resultArray);
           // resultArray.unshift({clid:"0",clnm:"ALL",clcd:"ALL"});
           var res=resultArray;
            this.corclasses = res;
            
            // this.cmodel.clid=res[0].clid;
            this.amodel.clid=res[0].clid;
            this.corsection1();
           // this.masperiod();
           // this.mascourse();
           
        },
        error => console.log("Error :: " + error)
        )
  }

  

  corsection() {
    this.mservice.sectionsrolewise(0,this.cmodel.crid,this.cmodel.clid,'section')
        .subscribe(
        resultArray => {
            console.log('getdashcounts', resultArray);
            //resultArray.unshift({scid:"0",scnm:"ALL",sccd:"ALL"});
            this.corsections = resultArray;
            
            this.cmodel.scid=resultArray[0].scid;
            this.amodel.scid=resultArray[0].scid;
            this.corsubject();
            //this.subjects();
            this.subjects(this.cmodel.clid,this.cmodel.crid);
        },
        error => console.log("Error :: " + error)
        )
  }

   corsection1() {
    this.mservice.sectionsrolewise(0,this.amodel.crid,this.amodel.clid,'section')
        .subscribe(
        resultArray => {
            console.log('getdashcounts', resultArray);
            //resultArray.unshift({scid:"0",scnm:"ALL",sccd:"ALL"});
            this.corsections = resultArray;
            
            // this.cmodel.scid=resultArray[0].scid;
            this.amodel.scid=resultArray[0].scid;
            this.corsubject();
            //this.subjects();
            this.subjects(this.cmodel.clid,this.cmodel.crid);
        },
        error => console.log("Error :: " + error)
        )
  }

  mascourse() {
      this.mservice.mascourse()
          .subscribe(
          resultArray => {
              console.log('getdashcounts', resultArray);
             // resultArray.unshift({crid:"0",crnm:"ALL",crcd:"ALL"});
              this.arrcourse = resultArray;
              this.fmodel.crid=resultArray[0].crid;
              this.fmodel1.crid=resultArray[0].crid;
              this.cmodel.crid=resultArray[0].crid;
              this.amodel.crid=resultArray[0].crid;
            
              this.corclass();
          },
          error => console.log("Error :: " + error)
          )
    }

 
    corsubject() {
      this.mservice.staffrolewise()
          .subscribe(
          resultArray => {
              console.log('getdashcounts', resultArray);
              //resultArray.unshift({emid:"0",emnm:"ALL"});
           //  resultArray.shift();
              this.corsubjects = resultArray;
             
              this.cmodel.emid=resultArray[0].emid;
              this.amodel.emid=resultArray[0].emid;
              this.objoff.emid=resultArray[0].emid;
              this.SelectAttdcorDetails('sel');
              this.SelectAttdcorDetails('seloff');
          },
          error => console.log("Error :: " + error)
          )
    }


    getstaff() {
      this.mservice.staffrolewise()
          .subscribe(
          resultArray => {
              console.log('getdashcounts', resultArray);
              //resultArray.unshift({emid:"0",emnm:"ALL"});
              //resultArray.shift();
              this.arrstaff = resultArray;
             
              this.cmodel.emid1=resultArray[0].emid;
              this.selworklist();
          },
          error => console.log("Error :: " + error)
          )
    }


    subjects(clid,crid) {
      this.mservice.subjectsrolewise(0,0,clid,'asaa',crid)
          .subscribe(
          resultArray => {
              console.log('getdashcounts', resultArray);
              this.arrsubjects = resultArray;
              //this.corsubjects = resultArray;
              this.cmodel.suid=resultArray[0].suid;
              this.getobemtpmap(clid,crid,resultArray[0].suid);
           //   this.attsubsum();
             // this.cmodel.suid=resultArray[0].suid;
             // this.SelectAttdDetails();
             
          },
          error => console.log("Error :: " + error)
          )
    }

    masgeneral(tag) {
      this.mservice.masgeneral(tag)
          .subscribe(
          resultArray => {
              console.log('arrmtongue', resultArray);
              if (tag=='wktype')
              {
              this.arrwktype = resultArray;
              
              }
    
              else if (tag=='wkstatus')
              {
              this.arrwkstatus = resultArray;
              }
             
          },
          error => console.log("Error :: " + error)
          )
    }
  
    


onclichlist()
{

  this.cmodel.frdt=this.mservice.getdatetoday();
  this.cmodel.todt=this.mservice.getdatetoday();
  this.getstaff();
}

onoffclick()
{

  this.objoff.frdt=this.mservice.getdatetoday();
  this.objoff.todt=this.mservice.getdatetoday();
  // this.getstaff();
}


onclickatt()
{

  this.amodel.frdt=this.mservice.getdatetoday();
  this.amodel.todt=this.mservice.getdatetoday();
  this.selectconsattdetails();
}


exportconrpt()
{
  var clcd=localStorage.getItem('clcd');
  var aycd=localStorage.getItem('aycd');
   var url=this.mservice.callurl+"export/expworkconatt.php?clcd="+clcd+"&aycd="+aycd+"&frdt="+this.amodel.frdt+"&todt="+this.amodel.todt+"&clid="+this.amodel.clid+"&scid="+this.amodel.scid+"&crid="+this.amodel.crid+"&emid="+this.amodel.emid;
   console.log("url",url)
   window.open(url,'');

}

// exptopdf()
// {
//   var clcd=localStorage.getItem('clcd');
//   var aycd=localStorage.getItem('aycd');
//   if(this.cmodel.oprtype=="detail")
//   {
//    var url=this.aservice.callurl+"pdf2/staftimesheet.php?clcd="+clcd+"&aycd="+aycd+"&dtfrm="+this.cmodel.frdt+"&dtto="+this.cmodel.todt+"&clid="+this.cmodel.clid+"&scid="+this.cmodel.scid+"&crid="+this.cmodel.crid+"&chtype="+this.cmodel.oprtype+"&emid="+this.cmodel.emid;
//   }
//   else if(this.cmodel.oprtype=="consolid")
//   {
//     var url=this.aservice.callurl+"pdf2/staftimesheet_cons.php?clcd="+clcd+"&aycd="+aycd+"&dtfrm="+this.cmodel.frdt+"&dtto="+this.cmodel.todt+"&clid="+this.cmodel.clid+"&scid="+this.cmodel.scid+"&crid="+this.cmodel.crid+"&chtype="+this.cmodel.oprtype+"&emid="+this.cmodel.emid;
//   }
//    console.log("url",url)
//    window.open(url,'');

// }


// exportatsumsubrpt()
// {
//   var clcd=localStorage.getItem('clcd');
//   var aycd=localStorage.getItem('aycd');
//    var url=this.aservice.callurl+"export/expatsumsub.php?clcd="+clcd+"&aycd="+aycd+"&dtfrm="+this.cmodel.frdt+"&dtto="+this.cmodel.todt+"&clid="+this.cmodel.clid+"&scid="+this.cmodel.scid+"&crid="+this.cmodel.crid+"&suid="+this.cmodel.suid;
//    console.log("url",url)
//    window.open(url,'');

// }
    

    
    SelectAttdcorDetails(oprtype) {
      debugger

      console.log('pstdat1',this.cmodel);

      this.sservice.selhrmworkdairy(this.cmodel, oprtype)
      .subscribe(resultArray => {
          console.log('ret-by-atd', resultArray);
          if(oprtype=='sel')
          {
            this.attcordata = resultArray;
          }
          else if(oprtype=='seloff')
          {
            this.arroff = resultArray;
          }
          // this.attcordata = resultArray;

          //alert(resultArray.message);

      }, error =>
          alert('error in connection')
      );
    }

     
    selofflinedet(oprtype) {
      debugger

      console.log('pstdat1',this.objoff);

      this.sservice.selhrmworkdairy(this.objoff, oprtype)
      .subscribe(resultArray => {
          console.log('ret-by-atd', resultArray);
         
            this.arroff = resultArray;
          

      }, error =>
          alert('error in connection')
      );
    }
  


    selectconsattdetails() {
      debugger

      console.log('pstdat1',this.amodel);

      this.sservice.selhrmworkdairywithatt(this.amodel)
      .subscribe(resultArray => {
          console.log('ret-by-atd', resultArray);
          this.attcondata = resultArray;

          //alert(resultArray.message);

      }, error =>
          alert('error in connection')
      );
    }

    exportcolrpt()
    {
      var clcd=localStorage.getItem('clcd');
      var aycd=localStorage.getItem('aycd');
       var url=this.mservice.callurl+"export/expworkdairy.php?clcd="+clcd+"&aycd="+aycd+"&frdt="+this.cmodel.frdt+"&todt="+this.cmodel.todt+"&emid="+this.cmodel.emid1;
          console.log("url",url);
       window.open(url,'');
    
    }  
    selworklist() {
      debugger

      console.log('pstdat1',this.cmodel);

      this.sservice.selworklist(this.cmodel)
      .subscribe(resultArray => {
          console.log('ret-by-atd', resultArray);
          this.arrworklist = resultArray;

          //alert(resultArray.message);

      }, error =>
          alert('error in connection')
      );
    }
 
SaveDetails() {

 // var clssubdata = {astmfm:from,astmto:to, clid: clid, suid: subid, oprtag: this.objsch.oprtype,asid:assid,astpid:asstypeid,portion:portion,rmk:remarks,asdt:assdt,clcd:clcd,aycd:aycd,baid:baid };
  
  
 
  console.log('save-model', this.objsubalot);
  this.sservice.savehrmworkdairy( this.objsubalot)
      .subscribe(resultArray => {
          console.log('ret-save', resultArray);
          
          alert (resultArray.message);
          if(resultArray.status=='success')
          {
            let localmodref=this.modalRef;
            localmodref.close();
           // this.Getsel_sp_massubgp();
           this.SelectAttdcorDetails('sel');
          }
          

      }, error =>
          alert('error in connection')
      );
 // this.closeAddExpenseModal.nativeElement.click();
}


 SaveoffDetails() {
  
   // var clssubdata = {astmfm:from,astmto:to, clid: clid, suid: subid, oprtag: this.objsch.oprtype,asid:assid,astpid:asstypeid,portion:portion,rmk:remarks,asdt:assdt,clcd:clcd,aycd:aycd,baid:baid };
    
    this.objoffline.suid=0;
    this.objoffline.crid=0;
    this.objoffline.clid=0;
    this.objoffline.scid=0;
    // this.objoffline.emid=0;
    // this.objoffline.wkstdt=this.localCompleteDate;
    // this.objsubalot.wkendt=this.localCompleteDate;
    this.objoffline.wkcpdt='';
    this.objoffline.wkstatus='2';
    this.objoffline.wktype='2';
    // this.objsubalot.wkdisc="";
    this.objoffline.rmk="";
    // this.objsubalot.oprtype='insert';

   
    console.log('save-model', this.objoffline);
    this.sservice.savehrmworkdairy( this.objoffline)
        .subscribe(resultArray => {
            console.log('ret-save', resultArray);
            
            alert (resultArray.message);
            if(resultArray.status=='success')
            {
              let localmodref=this.modalRef;
              localmodref.close();
             // this.Getsel_sp_massubgp();
             this.selofflinedet('seloff');
            }
            
  
        }, error =>
            alert('error in connection')
        );
   // this.closeAddExpenseModal.nativeElement.click();
  }

  deloffactivity(objdata)
  {
   if(confirm("Are you sure to delete this record?"))
    {
    this.objoffline=objdata;
    this.objoffline.oprtype='delete';
    this.sservice.savehrmworkdairy( this.objoffline)
        .subscribe(resultArray => {
            console.log('ret-save', resultArray);
            
            alert (resultArray.message);
            this.selofflinedet('seloff');
            
  })
}
}



  delclassactivity(objdata)
  {
   if(confirm("Are you sure to delete this record?"))
    {
    this.objsubalot=objdata;
    this.objsubalot.oprtype='delete';
    this.sservice.savehrmworkdairy( this.objsubalot)
        .subscribe(resultArray => {
            console.log('ret-save', resultArray);
            
            alert (resultArray.message);
            this.SelectAttdcorDetails('sel');
            
  })
}
}


          onmemberselectEvent(item) {

    console.log('item',item);
    // this.objlevel.duration=item.duration;
    this.objsubalot.tpid=item.tpid;
   }
        onmemberChangeSearch(sertxt) {
    debugger
  

  

  this.arflstudent= this.arreval.filter(item => {
      
      const nameMatches = item.tpnm.toLowerCase().includes(sertxt.toLowerCase());
     
      return nameMatches ; 
    });
    console.log('arflstudent',this.arflstudent);
  }


  //  onsubchange()
  //       {
  //         var pst={clid:this.objfilt.clid,crid:this.objfilt.crid,suid:this.objlevel.suid};
  //         this.getobemtpmap(pst);
  //       }

 
       getobemtpmap(clid,crid,suid) {
        var pst={clid:clid,crid:crid,suid:suid};
          this.mservice.getobemtpmap(pst)
              .subscribe(
              resultArray => {
                  console.log('getdashcounts', resultArray);
                  this.arreval = resultArray;
                 
              },
              error => console.log("Error :: " + error)
              )
        }

      openoffline(content,objdata,cmd) {
        debugger
         
        // this.subjects(this.cmodel.clid,this.cmodel.crid);
          if(cmd=="insert")
          {
           // this.objsubalot={};
            this.objoffline.rid=0;
            this.objoffline.wkstdt=this.localCompleteDate;
            this.objoffline.wkendt=this.localCompleteDate;
            // this.objsubalot.wkcpdt=this.localCompleteDate;
            // this.objsubalot.crid=this.cmodel.crid;
            // this.objsubalot.clid=this.cmodel.clid;
            // this.objsubalot.scid=this.cmodel.scid;
            this.objoffline.emid=this.cmodel.emid;
            // this.objsubalot.suid=this.cmodel.suid;
            // this.objsubalot.wkstatus=this.arrwkstatus[0].gcd;
            // this.objsubalot.wktype=this.arrwktype[0].gcd;
            this.objoffline.wkdisc="";
            this.objoffline.rmk="";
            this.objoffline.oprtype=cmd;
  
          }
          else if(cmd=="update")
          { this.objoffline=objdata;
            this.objoffline.oprtype=cmd;
            
          }
         // this.getattdetails();
          this.modalOptions = {
            backdrop:'static',
            backdropClass:'customBackdrop',
            size:'md'
           
          }
          this.modalRef=this.modalService.open(content,this.modalOptions);
          
          this.modalRef.result.then((result) => {
         
               
            }, (reason) => {
                
            });
        }
  

    openentry(content,objdata,cmd) {
      debugger
       
      this.subjects(this.cmodel.clid,this.cmodel.crid);
        if(cmd=="insert")
        {
         // this.objsubalot={};
          this.objsubalot.rid=0;
          this.objsubalot.wkstdt=this.localCompleteDate;
          this.objsubalot.wkendt=this.localCompleteDate;
          this.objsubalot.wkcpdt=this.localCompleteDate;
          this.objsubalot.crid=this.cmodel.crid;
          this.objsubalot.clid=this.cmodel.clid;
          this.objsubalot.scid=this.cmodel.scid;
          this.objsubalot.emid=this.cmodel.emid;
          this.objsubalot.suid=this.cmodel.suid;
          this.objsubalot.wkstatus=this.arrwkstatus[0].gcd;
          this.objsubalot.wktype=this.arrwktype[0].gcd;
          this.objsubalot.wkdisc="";
          this.objsubalot.rmk="";
          this.objsubalot.oprtype=cmd;

        }
        else if(cmd=="update")
        { 
          
          this.objsubalot=objdata;
          this.getobemtpmap(this.objsubalot.clid,this.objsubalot.crid,this.objsubalot.suid);
          this.objsubalot.oprtype=cmd;
          
        }
       // this.getattdetails();
        this.modalOptions = {
          backdrop:'static',
          backdropClass:'customBackdrop',
          size:'lg'
         
        }
        this.modalRef=this.modalService.open(content,this.modalOptions);
        
        this.modalRef.result.then((result) => {
       
             
          }, (reason) => {
              
          });
      }
      



}
